module.exports = __webpack_public_path__ + "img/trunk_1x1_z16.87db25b1.svg";